import { reactive } from "vue";
export const tradeFabDetailContext = reactive({
    fullPath: "",
    uniqueGId: "",
    gNum: "",
    albumName: "",
    price: ""
});
export function syncTradeFabFromProductDetail(payload) {
    tradeFabDetailContext.fullPath = payload.fullPath || "";
    tradeFabDetailContext.uniqueGId = payload.uniqueGId || "";
    tradeFabDetailContext.gNum = payload.gNum || "";
    tradeFabDetailContext.albumName = payload.albumName || "";
    tradeFabDetailContext.price = payload.price || "";
}
export function clearTradeFabDetailContext() {
    tradeFabDetailContext.fullPath = "";
    tradeFabDetailContext.uniqueGId = "";
    tradeFabDetailContext.gNum = "";
    tradeFabDetailContext.albumName = "";
    tradeFabDetailContext.price = "";
}
